
import { common } from '@tencent/ceiba-base-components';

const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  console.log('pluginName=', `$${name}${camelize(`-${ast}`)}Plugin`);
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}
const openUrl = (url, target = '_self') => {
  try {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = url;
      return;
    }
    const newTab = window.open('', target);
    newTab.opener = null;
    newTab.location = url;
  } catch (error) {
    console.error('openUrl fail, err=', error);
    window.location.href = url;
  }
};

// 获取链接上的参数
const getValueFromUrl = (arr, link) => {
  let newLink = link;
  arr.forEach((v) => {
    console.log('paramsStr.v', v);
    const mapKv = v.split(':');
    if (mapKv.length === 2) {
      const getVal = common.tool.getQueryparams(mapKv[0]) || '';
      console.log('paramsStr.getVal mapKv ', mapKv, getVal);
      newLink = common.tool.setUrlParam(`${mapKv[1]}`, `${getVal}`, newLink);
    } else {
      const getVal = common.tool.getQueryparams(v) || '';
      console.log('paramsStr.getVal', getVal);
      newLink = common.tool.setUrlParam(`${v}`, `${getVal}`, newLink);
    }
  });
  return newLink;
};

const openerPlugin = {
  install(Vue) {
    Vue.prototype.$opener = {
      getOpenViewSchema: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema(params);
        }
        return;
      },
      openView: async (params, store) => {
        // 处理自定义透传参数的问题
        const KeyArr = params.paramStr?.split('|') ?? [];
        if (KeyArr.length > 0) {
          console.log('defaultKeyArr', KeyArr);
          params.url = getValueFromUrl(KeyArr, params.url);
          console.log('params.url', params.url);
        }
        console.log('openView params=', params, store);
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].openView) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].openView(params, store);
        }

        openUrl(params.url, params.target);
      },
    };
  },
};

export default openerPlugin;
